<template>
  <div class="rounded-3xl overflow-hidden">
    <el-menu class="desktop-menus" :default-active="activeMenu" :collapse="collapse">
      <menus-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
      />
    </el-menu>
  </div>
</template>

<script>

import MenusItem from "./MenusItem";
import permission_routes from "@/routers/admin";

export default {
  components: {MenusItem},
  props: {
    collapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    permission_routes() {
      return permission_routes;
    },
    activeMenu() {
      const route = this.$route;
      const {meta, path} = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  },
};
</script>

<style lang="scss">
.desktop-menus {

  .el-submenu__title .el-icon-arrow-right {
    display: none !important;
  }

}

.desktop-menus.el-menu {
  border-right: 0;
}

</style>
